import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const checkoutUpdateUserInformationActions = createDataModuleActions(
    'CHECKOUT_UPDATE_USER_INFORMATION',
);

export const checkoutUpdateUserInformation =
    checkoutUpdateUserInformationActions.dataRequest;
export const checkoutUpdateUserInformationSuccess =
    checkoutUpdateUserInformationActions.dataSuccess;
export const checkoutUpdateUserInformationError =
    checkoutUpdateUserInformationActions.dataError;
export const checkoutUpdateUserInformationReset =
    checkoutUpdateUserInformationActions.dataReset;
